import {isTouchDevice} from "@/modules/utils/deviceUtils";
import {usePageResize} from "@/modules/reader/book/pageResize";
import {useTool} from "@/modules/reader/tools/tools"
import {usePaging} from "@/modules/reader/book/paging";
import {onMouseUp} from "../reader/tools/drawing/freehandTool";
import cssvar from '@/scss/_variables.scss';
import config from "@/config/config.json";

let canvasBoundLeft;//get the canvas left client position for touch device
let canvasBoundTop;//get the canvas top client position for touch device
let tmpCanvasData = null;
const {pageResizeState} = usePageResize();
const {pageState} = usePaging();
const headerHeight = parseInt(cssvar.headerHeight);

/**
 * Save temp data so that on mouse move, so that the previous drawn objects can be kept
 */
const saveTmpCanvasData = (ctx)=> {
    tmpCanvasData =  ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
}

/**
 * restore temp data so that on mouse move, so that the previous drawn objects can be seen
 */
const restoreTmpCanvasData = (ctx)=> {
    if (tmpCanvasData) {
        ctx.putImageData(tmpCanvasData, 0, 0);
    }
}

/**
 * Get the canvas left and top position for positioning the correct touch point on touchable devices
 * @param canvasEl
 */
const setCanvasClientPos =(canvasEl)=>{
    if (isTouchDevice()) {
        let canvasBound = canvasEl.getBoundingClientRect();
        canvasBoundLeft = canvasBound.x;
        canvasBoundTop = canvasBound.y;
    }
}

/**
* Retrieve the touch position.
* We use event.offsetX and event.offsetY with mouse event on non-touchable devices.
* However, these properties don't work on touch devices.
* Instead, first get the canvas left top position, and get the touch pageX and pageY points
* to get the relative position to the canvas.
* @param e
* @returns {{x: *, y: *}|{x: number, y: number}}
*/
const getTouchOffset = (e)=> {


    if (isTouchDevice() && e.changedTouches && e.changedTouches.length) {

        //note that zoom level has to be considered on touch device
        let x,y,zoomLevel;
        let canvasId = e.target.id;

        x = e.changedTouches[0].pageX - document.querySelector("body").scrollLeft  - canvasBoundLeft;
        y = e.changedTouches[0].pageY - document.querySelector("body").scrollTop   - canvasBoundTop;



        if (pageState.isRightPageAvailable) {
            if (canvasId.indexOf("tool-canvas-left")>=0) {
                zoomLevel =  pageResizeState.zoomLevelLeft;

            }
            else if (canvasId.indexOf("tool-canvas-right")>=0) {
                zoomLevel =  pageResizeState.zoomLevelRight;
            }
        } else {
            zoomLevel = pageResizeState.zoomLevel;
        }

        //Please refer to ToolCanvas.vue, the canvas size is divided by 2 to avoid too large resolution problem on tablet devices (tested that clearCanvas may not work)
        //so the x, y coordinates will have to be divided by 2 accordingly:
        return {
            x:x * useTool().toolState.canvasScale / zoomLevel / 2,
            y:y * useTool().toolState.canvasScale /zoomLevel / 2
        }
    } else {

        return {
            x:e.offsetX / (1/useTool().toolState.canvasScale * 2),
            y:e.offsetY /(1/useTool().toolState.canvasScale * 2)
        }
    }

}

/**
 * Detect if the mouse / touch point has been moved out of the drawing area. If yes, stop drawing
 * @param e
 */
const checkIsOutOfCanvas = (e, callBack) =>{
    if (!e.toElement.classList || !e.toElement.classList.contains("note-element")) {
        callBack(e);
    }
}

export {
    saveTmpCanvasData,
    restoreTmpCanvasData,
    getTouchOffset,
    setCanvasClientPos,
    checkIsOutOfCanvas
}
